<div class="header_search">
  <div class="title-page">
    <h3>Projetos Agregadores</h3>
  </div>
</div>

<div class="system-table table-container" *ngIf="!isLoading">
  <div class="system-table-conteiner">
    <table>
      <thead>
        <tr>
          <th class="title-agregador">Projeto Agregador</th>
          <th>Órgão</th>
          <th class="acoes">Ações</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let projeto of lista">
          <tr>
            <td class="title">
              <span class="title-span">{{projeto?.title}}</span>
              <div class="responsavel">
                <img *ngIf="projeto?.resp_nome" src="assets/images/svgs/responsavel.svg" alt="Responsavel" [tooltip]="projeto?.resp_nome" placement="bottom" (click)="viewResonsavel(projeto)">
              </div>
            </td>
            <td>{{projeto?.agency_name}}</td>
            <td>
              <div class="btn-icon">
                <a class="icon-table" [routerLink]="editarClickHandler(projeto)">
                  <img src="assets/images/svgs/lupa.svg" tooltip="Visualizar" placement="bottom">
                </a>
              </div>
            </td>
          </tr>
        </ng-container>
        <tr *ngIf="!lista?.length" class="border-b-radius">
          <td colspan="7" class="text-center">Nenhum Projeto Agregador Encontrado.</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>
<app-modal-responsavel #modalResonsavel></app-modal-responsavel>